import { useEffect, useState } from "react";
import { OccService } from "../services/OccService";
import { useFetch } from "./useFetch";
import { useConfig } from "./useConfig";
import Sodmac from "../assets/svgs/sodimac.svg";
import Polishop from "../assets/svgs/logo_polishop.svg";

type StixForBusinessData = {
  stixParaEmpresas: {
    partners: {
      partner: [
        {
          id: string;
          imageLink: string;
          linkUrl: string;
          title: string;
        }
      ];
    };
  };
};

type Partner = {
  url: string;
  name: string;
  flag: "SOD" | "PLS" | "ST";
  logo: string;
  indicator?: "social" | "promoter";
};

type PartnerCarousel = {
  name: string;
  imageLink: string;
};

const partners: Partner[] = [
  {
    url: "sodimac",
    name: "Sodimac",
    flag: "SOD",
    logo: Sodmac,
  },
  {
    url: "polishop",
    name: "Polishop",
    flag: "PLS",
    logo: Polishop,
  },
  {
    flag: "ST",
    logo: "",
    name: "",
    url: "seja",
    indicator: "promoter",
  },
  {
    flag: "ST",
    logo: "",
    name: "",
    url: "stix",
    indicator: "social",
  },
];

export function usePartner() {
  const { data: partnersData } = useFetch<StixForBusinessData>(
    OccService.getPartners
  );
  const { config } = useConfig();

  const [partnerName, setPartnerName] = useState("");
  const [partnerFlag, setPartnerFlag] = useState<Partner["flag"]>();
  const [partnerLogo, setPartnerLogo] = useState<string | null>(null);
  const [partnerIndicator, setPartnerIndicator] =
    useState<Partner["indicator"]>();
  const [partnersCarousel, setPartnersCarousel] = useState<PartnerCarousel[]>(
    []
  );

  useEffect(() => {
    const isPartner = (label: string) => {
      const url = window.location.href;

      const isIncludes = (split: string) =>
        url
          .toLocaleLowerCase()
          .split(split)
          .find((item) => item.includes(label));

      if (url.includes("localhost")) {
        return isIncludes("?");
      }

      return isIncludes(".");
    };

    const actualPartner: Partner = partners.find((partner) =>
      isPartner(partner.url)
    )!;

    setPartnerName(actualPartner?.name);
    setPartnerLogo(actualPartner?.logo);
    setPartnerFlag(actualPartner?.flag);
    setPartnerIndicator(actualPartner?.indicator);
  }, []);

  useEffect(() => {
    const carousel = partnersData?.stixParaEmpresas?.partners?.partner?.map(
      (partner) => {
        return {
          name: partner.title,
          imageLink: config?.productsUrl + partner.imageLink,
        };
      }
    );
    setPartnersCarousel(carousel!);
  }, [partnersData, config]);

  return {
    partnerName,
    partnerLogo,
    partnerFlag,
    partnerIndicator,
    partnersCarousel,
  };
}
